/**
 * Shared prose/markdown styling classes used by NarratorMessage and PlayMessageList.
 * Single source of truth — update here to affect all narrative text rendering.
 */
export const proseClasses =
  "prose prose-base dark:prose-invert max-w-none break-words overflow-hidden min-w-0 [overflow-wrap:anywhere] [word-break:break-word] text-foreground pr-1 " +
  "prose-p:my-3 prose-p:leading-relaxed prose-p:text-foreground " +
  "prose-ul:my-3 prose-ul:list-disc prose-ul:pl-6 prose-ul:space-y-1.5 " +
  "prose-ol:my-3 prose-ol:list-decimal prose-ol:pl-6 prose-ol:space-y-1.5 " +
  "prose-li:my-0.5 prose-li:pl-1 prose-li:text-foreground prose-li:marker:text-muted-foreground " +
  "prose-headings:mt-5 prose-headings:mb-2.5 prose-headings:font-semibold prose-headings:text-foreground " +
  "prose-h2:text-lg prose-h3:text-base " +
  "prose-strong:text-primary prose-strong:font-bold " +
  "prose-blockquote:border-l-2 prose-blockquote:border-primary/40 prose-blockquote:pl-4 prose-blockquote:italic prose-blockquote:text-muted-foreground " +
  "prose-code:bg-muted prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:text-sm " +
  "prose-hr:border-border [&>*:first-child]:mt-0 " +
  "prose-table:w-full prose-table:border-collapse prose-table:my-4 prose-table:text-sm " +
  "prose-thead:border-b-2 prose-thead:border-border " +
  "prose-th:px-3 prose-th:py-2 prose-th:text-left prose-th:font-semibold prose-th:text-foreground prose-th:bg-muted/30 " +
  "prose-td:px-3 prose-td:py-2 prose-td:border-b prose-td:border-border/50 prose-td:text-foreground " +
  "prose-tr:even:bg-muted/10";

